// get_walkthrough_steps
export const GET_WALKTHROUGH_STEP = 'get_walkthrough_steps';
export const GET_WALKTHROUGH_STEP_SUCCESSFUL =
  'get_walkthrough_steps_successfull';
export const GET_WALKTHROUGH_STEP_FAILED = 'get_walkthrough_steps_failed';

// create_walkthrough_step
export const CREATE_WALKTHROUGH_STEP = 'create_walkthrough_step';
export const CREATE_WALKTHROUGH_STEP_SUCCESSFUL =
  'create_walkthrough_step_successfull';
export const CREATE_WALKTHROUGH_STEP_FAILED = 'create_walkthrough_step_failed';

// update_walkthrough_step
export const UPDATE_WALKTHROUGH_STEP = 'update_walkthrough_step';
export const UPDATE_WALKTHROUGH_STEP_SUCCESSFUL =
  'update_walkthrough_step_successfull';
export const UPDATE_WALKTHROUGH_STEP_FAILED = 'update_walkthrough_step_failed';

// delete_walkthrough_step
export const DELETE_WALKTHROUGH_STEP = 'delete_walkthrough_step';
export const DELETE_WALKTHROUGH_STEP_SUCCESSFUL =
  'delete_walkthrough_step_successfull';
export const DELETE_WALKTHROUGH_STEP_FAILED = 'delete_walkthrough_step_failed';
// exchangewalkthroughsteporder
export const EXCHANGEWALKTHROUGHSTEPORDER = 'exchangewalkthroughsteporder';
export const EXCHANGEWALKTHROUGHSTEPORDER_SUCCESSFUL =
  'exchangewalkthroughsteporder_successfull';
export const EXCHANGEWALKTHROUGHSTEPORDER_FAILED =
  'exchangewalkthroughsteporder_failed';
